import React, { 
  useRef,
  useState, 
  useEffect 
} from 'react';
import { sanitizeHtmlContent } from '../utils/utils'

import { animate, useInView } from "framer-motion";

import {
  Statistic,
} from 'semantic-ui-react';

export default function ContentStatistics(props) {
  //console.log('ContentStatistics - props', props);

  const {
    widths,
    textAlign,
    animated,
    items
  } = props;

  const [statisticsState, setStatisticsState] = useState({
    animateableValues: null,
  });

  useEffect(() => {
    if (animated && statisticsState.animateableValues === null) {
      let parsedValues = [];
      for (const [index, item] of items.contentItems.entries()) {
        if (item.value && !item.text) {
          let parsedvalue = {
            idx: index,
            intialValues: item.value.split(/(\d+)/).filter(Boolean),
            finalValues: []
          }
          if (parsedvalue.intialValues.length !== 0) {
            for (let [index, value] of parsedvalue.intialValues.entries()) {
              const prevIndexValue = parsedvalue.intialValues[(index-1)];
              const nextIndexvalue = parsedvalue.intialValues[(index+1)];
              const valueAsNumber = parseFloat(value);
              if (parsedvalue.finalValues.length === 0) {
                if (parsedvalue.intialValues.length > 2 && value === ',' && prevIndexValue && nextIndexvalue) {
                  const mergedValue = parseFloat(prevIndexValue+''+nextIndexvalue)
                  //const finalArray = [ mergedValue, parsedvalue.intialValues.slice(-1)[0] ];
                  parsedvalue.finalValues = [ mergedValue, parsedvalue.intialValues.slice(-1)[0] ]
                }
                if (parsedvalue.intialValues.length === 2 && valueAsNumber) {
                  parsedvalue.finalValues = [ valueAsNumber, parsedvalue.intialValues.slice(-1)[0] ]
                }
              }
            }
          }
          parsedValues = [...parsedValues, parsedvalue]
        }
      }
      if (parsedValues.length !== 0) {
        setStatisticsState({...statisticsState , animateableValues: parsedValues});
      }
    }
  }, [items, animated, statisticsState,]);  
  
  return (
    <>
      <div className={'site-content-statistic'} style={{ textAlign: textAlign ? textAlign : null}}>
        {items && items.contentItems.length > 1 ?
          <Statistic.Group widths={widths ? widths : null} className={textAlign === 'center' ? 'centered' : null}>
          {items.contentItems.map((statistic, i) => {
            return (
              <Statistic key={i}>
                <Statistic.Value text={statistic.text ? statistic.text : null} className={animated ? 'animated' : null}>
                  {animated && !statistic.text && statisticsState.animateableValues !== null && statisticsState.animateableValues[i] && statisticsState.animateableValues[i].length !== 0 && statisticsState.animateableValues[i].finalValues[0] ?
                    <>
                      <AnimatedCounter from={0} to={statisticsState.animateableValues[i].finalValues[0]} />
                      {statisticsState.animateableValues[i].finalValues[1] ?
                        <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(statisticsState.animateableValues[i].finalValues[1])}}></div>
                      :
                        null
                      }
                    </>
                  :
                    <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(statistic.value)}}></div>
                  }
                </Statistic.Value>
                <Statistic.Label>
                  <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(statistic.label)}}></div>
                </Statistic.Label>
              </Statistic>
            )
          })}
          </Statistic.Group>
        :
          <Statistic>
            <Statistic.Value text={items.contentItems[0].text ? items.contentItems[0].text : null}>
              <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(items.contentItems[0].value)}}></div>
            </Statistic.Value>
            <Statistic.Label>
              <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(items.contentItems[0].label)}}></div>
            </Statistic.Label>
          </Statistic>
        }
      </div>
    </>
  )
}

function AnimatedCounter({ from, to }) {
  const ref = useRef();
  const isInView = useInView(ref, { once: true })
  useEffect(() => {
    if (!isInView) return;
    const controls = animate(from, to, {
      delay: 0.5,
      duration: 2,
      type: "spring",
      onUpdate(value) {
        ref.current.textContent = value.toLocaleString('en',{minimumFractionDigits: 0,maximumFractionDigits: 0});
      }
    });
    return () => controls.stop();
  }, [isInView, from, to]);

  return <p ref={ref} />;
}